import { GET_ENC, POST_ENC } from "../common/EncryptedHttp";
import { BASE_URL } from "../common/const";

const BASE = `${BASE_URL}/api/OpthalIOP`;


export const GetMeasurementMethodList = (params: URLSearchParams) => {
  return GET_ENC(
    `${BASE}/GetMeasurementMethodList?${params.toString()}`,
    null
  );
};


export const GetMeasurementMethodDetail = (params: URLSearchParams) => {
  return GET_ENC(
    `${BASE}/GetMeasurementMethodDetail?${params.toString()}`,
    null
  );
};

export const CreateMeasurementMethod = (data: any) => {
  return POST_ENC(`${BASE}/CreateMeasurementMethod`, data);
};


export const UpdateMeasurementMethod = (data: any) => {
  return POST_ENC(`${BASE}/UpdateMeasurementMethod`, data);
};


export const DeleteMeasurementMethod = (data: any) => {
  return POST_ENC(`${BASE}/DeleteMeasurementMethod`, data);
};